'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = _interopDefault(require('react'));
var styled = _interopDefault(require('styled-components'));
var functions = require('@keytrade/functions');
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var SpinnerIcon = function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.384615, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.333087, 2.996155) rotate(30.000000) translate(-12.333087, -2.996155) translate(11.333087, 0.996155)",
    fillOpacity: "0.9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.395607, 5.331993) rotate(60.000000) translate(-14.395607, -5.331993) translate(13.395607, 3.331993)",
    fillOpacity: "0.84"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "-0.00262640682",
    y: "0.00673589553",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 8.384615) rotate(90.000000) translate(-15.000000, -8.384615) translate(14.000000, 6.384615)",
    fillOpacity: "0.76"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.003845, 11.333087) rotate(120.000000) translate(-14.003845, -11.333087) translate(13.003845, 9.333087)",
    fillOpacity: "0.68"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.666913, 13.388460) rotate(150.000000) translate(-11.666913, -13.388460) translate(10.666913, 11.388460)",
    fillOpacity: "0.6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.615385, 14.000000) rotate(180.000000) translate(-8.615385, -14.000000) translate(7.615385, 12.000000)",
    fillOpacity: "0.52"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.666913, 13.003845) rotate(-150.000000) translate(-5.666913, -13.003845) translate(4.666913, 11.003845)",
    fillOpacity: "0.44"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.611540, 10.666913) rotate(-120.000000) translate(-3.611540, -10.666913) translate(2.611540, 8.666913)",
    fillOpacity: "0.36"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 7.615385) rotate(-90.000000) translate(-3.000000, -7.615385) translate(2.000000, 5.615385)",
    fillOpacity: "0.28"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.314474, 4.843698) rotate(-60.000000) translate(-3.314474, -4.843698) translate(1.814474, 2.343698)",
    fillOpacity: "0.2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0.993941209",
    y: "1.00196102",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.333087, 2.611540) rotate(-30.000000) translate(-6.333087, -2.611540) translate(5.333087, 0.611540)",
    fillOpacity: "0.12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  }))))));
};
var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
var focusVisible = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
    factory();
  })(commonjsGlobal, function () {
    /**
     * Applies the :focus-visible polyfill at the given scope.
     * A scope in this case is either the top-level Document or a Shadow Root.
     *
     * @param {(Document|ShadowRoot)} scope
     * @see https://github.com/WICG/focus-visible
     */
    function applyFocusVisiblePolyfill(scope) {
      var hadKeyboardEvent = true;
      var hadFocusVisibleRecently = false;
      var hadFocusVisibleRecentlyTimeout = null;
      var inputTypesWhitelist = {
        text: true,
        search: true,
        url: true,
        tel: true,
        email: true,
        password: true,
        number: true,
        date: true,
        month: true,
        week: true,
        time: true,
        datetime: true,
        'datetime-local': true
      };

      /**
       * Helper function for legacy browsers and iframes which sometimes focus
       * elements like document, body, and non-interactive SVG.
       * @param {Element} el
       */
      function isValidFocusTarget(el) {
        if (el && el !== document && el.nodeName !== 'HTML' && el.nodeName !== 'BODY' && 'classList' in el && 'contains' in el.classList) {
          return true;
        }
        return false;
      }

      /**
       * Computes whether the given element should automatically trigger the
       * `focus-visible` class being added, i.e. whether it should always match
       * `:focus-visible` when focused.
       * @param {Element} el
       * @return {boolean}
       */
      function focusTriggersKeyboardModality(el) {
        var type = el.type;
        var tagName = el.tagName;
        if (tagName == 'INPUT' && inputTypesWhitelist[type] && !el.readOnly) {
          return true;
        }
        if (tagName == 'TEXTAREA' && !el.readOnly) {
          return true;
        }
        if (el.isContentEditable) {
          return true;
        }
        return false;
      }

      /**
       * Add the `focus-visible` class to the given element if it was not added by
       * the author.
       * @param {Element} el
       */
      function addFocusVisibleClass(el) {
        if (el.classList.contains('focus-visible')) {
          return;
        }
        el.classList.add('focus-visible');
        el.setAttribute('data-focus-visible-added', '');
      }

      /**
       * Remove the `focus-visible` class from the given element if it was not
       * originally added by the author.
       * @param {Element} el
       */
      function removeFocusVisibleClass(el) {
        if (!el.hasAttribute('data-focus-visible-added')) {
          return;
        }
        el.classList.remove('focus-visible');
        el.removeAttribute('data-focus-visible-added');
      }

      /**
       * If the most recent user interaction was via the keyboard;
       * and the key press did not include a meta, alt/option, or control key;
       * then the modality is keyboard. Otherwise, the modality is not keyboard.
       * Apply `focus-visible` to any current active element and keep track
       * of our keyboard modality state with `hadKeyboardEvent`.
       * @param {KeyboardEvent} e
       */
      function onKeyDown(e) {
        if (e.metaKey || e.altKey || e.ctrlKey) {
          return;
        }
        if (isValidFocusTarget(scope.activeElement)) {
          addFocusVisibleClass(scope.activeElement);
        }
        hadKeyboardEvent = true;
      }

      /**
       * If at any point a user clicks with a pointing device, ensure that we change
       * the modality away from keyboard.
       * This avoids the situation where a user presses a key on an already focused
       * element, and then clicks on a different element, focusing it with a
       * pointing device, while we still think we're in keyboard modality.
       * @param {Event} e
       */
      function onPointerDown(e) {
        hadKeyboardEvent = false;
      }

      /**
       * On `focus`, add the `focus-visible` class to the target if:
       * - the target received focus as a result of keyboard navigation, or
       * - the event target is an element that will likely require interaction
       *   via the keyboard (e.g. a text box)
       * @param {Event} e
       */
      function onFocus(e) {
        // Prevent IE from focusing the document or HTML element.
        if (!isValidFocusTarget(e.target)) {
          return;
        }
        if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
          addFocusVisibleClass(e.target);
        }
      }

      /**
       * On `blur`, remove the `focus-visible` class from the target.
       * @param {Event} e
       */
      function onBlur(e) {
        if (!isValidFocusTarget(e.target)) {
          return;
        }
        if (e.target.classList.contains('focus-visible') || e.target.hasAttribute('data-focus-visible-added')) {
          // To detect a tab/window switch, we look for a blur event followed
          // rapidly by a visibility change.
          // If we don't see a visibility change within 100ms, it's probably a
          // regular focus change.
          hadFocusVisibleRecently = true;
          window.clearTimeout(hadFocusVisibleRecentlyTimeout);
          hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
            hadFocusVisibleRecently = false;
            window.clearTimeout(hadFocusVisibleRecentlyTimeout);
          }, 100);
          removeFocusVisibleClass(e.target);
        }
      }

      /**
       * If the user changes tabs, keep track of whether or not the previously
       * focused element had .focus-visible.
       * @param {Event} e
       */
      function onVisibilityChange(e) {
        if (document.visibilityState == 'hidden') {
          // If the tab becomes active again, the browser will handle calling focus
          // on the element (Safari actually calls it twice).
          // If this tab change caused a blur on an element with focus-visible,
          // re-apply the class when the user switches back to the tab.
          if (hadFocusVisibleRecently) {
            hadKeyboardEvent = true;
          }
          addInitialPointerMoveListeners();
        }
      }

      /**
       * Add a group of listeners to detect usage of any pointing devices.
       * These listeners will be added when the polyfill first loads, and anytime
       * the window is blurred, so that they are active when the window regains
       * focus.
       */
      function addInitialPointerMoveListeners() {
        document.addEventListener('mousemove', onInitialPointerMove);
        document.addEventListener('mousedown', onInitialPointerMove);
        document.addEventListener('mouseup', onInitialPointerMove);
        document.addEventListener('pointermove', onInitialPointerMove);
        document.addEventListener('pointerdown', onInitialPointerMove);
        document.addEventListener('pointerup', onInitialPointerMove);
        document.addEventListener('touchmove', onInitialPointerMove);
        document.addEventListener('touchstart', onInitialPointerMove);
        document.addEventListener('touchend', onInitialPointerMove);
      }
      function removeInitialPointerMoveListeners() {
        document.removeEventListener('mousemove', onInitialPointerMove);
        document.removeEventListener('mousedown', onInitialPointerMove);
        document.removeEventListener('mouseup', onInitialPointerMove);
        document.removeEventListener('pointermove', onInitialPointerMove);
        document.removeEventListener('pointerdown', onInitialPointerMove);
        document.removeEventListener('pointerup', onInitialPointerMove);
        document.removeEventListener('touchmove', onInitialPointerMove);
        document.removeEventListener('touchstart', onInitialPointerMove);
        document.removeEventListener('touchend', onInitialPointerMove);
      }

      /**
       * When the polfyill first loads, assume the user is in keyboard modality.
       * If any event is received from a pointing device (e.g. mouse, pointer,
       * touch), turn off keyboard modality.
       * This accounts for situations where focus enters the page from the URL bar.
       * @param {Event} e
       */
      function onInitialPointerMove(e) {
        // Work around a Safari quirk that fires a mousemove on <html> whenever the
        // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
        if (e.target.nodeName && e.target.nodeName.toLowerCase() === 'html') {
          return;
        }
        hadKeyboardEvent = false;
        removeInitialPointerMoveListeners();
      }

      // For some kinds of state, we are interested in changes at the global scope
      // only. For example, global pointer input, global key presses and global
      // visibility change should affect the state at every scope:
      document.addEventListener('keydown', onKeyDown, true);
      document.addEventListener('mousedown', onPointerDown, true);
      document.addEventListener('pointerdown', onPointerDown, true);
      document.addEventListener('touchstart', onPointerDown, true);
      document.addEventListener('visibilitychange', onVisibilityChange, true);
      addInitialPointerMoveListeners();

      // For focus and blur, we specifically care about state changes in the local
      // scope. This is because focus / blur events that originate from within a
      // shadow root are not re-dispatched from the host element if it was already
      // the active element in its own scope:
      scope.addEventListener('focus', onFocus, true);
      scope.addEventListener('blur', onBlur, true);

      // We detect that a node is a ShadowRoot by ensuring that it is a
      // DocumentFragment and also has a host property. This check covers native
      // implementation and polyfill implementation transparently. If we only cared
      // about the native implementation, we could just check if the scope was
      // an instance of a ShadowRoot.
      if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) {
        // Since a ShadowRoot is a special kind of DocumentFragment, it does not
        // have a root element to add a class to. So, we add this attribute to the
        // host element instead:
        scope.host.setAttribute('data-js-focus-visible', '');
      } else if (scope.nodeType === Node.DOCUMENT_NODE) {
        document.documentElement.classList.add('js-focus-visible');
      }
    }

    // It is important to wrap all references to global window and document in
    // these checks to support server-side rendering use cases
    // @see https://github.com/WICG/focus-visible/issues/199
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      // Make the polyfill helper globally available. This can be used as a signal
      // to interested libraries that wish to coordinate with the polyfill for e.g.,
      // applying the polyfill to a shadow root:
      window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill;

      // Notify interested libraries of the polyfill's presence, in case the
      // polyfill was loaded lazily:
      var event;
      try {
        event = new CustomEvent('focus-visible-polyfill-ready');
      } catch (error) {
        // IE11 does not support using CustomEvent as a constructor directly:
        event = document.createEvent('CustomEvent');
        event.initCustomEvent('focus-visible-polyfill-ready', false, false, {});
      }
      window.dispatchEvent(event);
    }
    if (typeof document !== 'undefined') {
      // Apply the polyfill to the global document, so that no JavaScript
      // coordination is required to use the polyfill in the top-level document:
      applyFocusVisiblePolyfill(document);
    }
  });
});

// See https://github.com/styled-components/babel-plugin-styled-components/issues/216
// @CSS_IMPORT_FIX const css = require('styled-components').css

var getFont = functions.config.fonts.getFont;
var colors = functions.config.colors.list;
var linkColors = {
  BlueSky: {
    active: 'BlueMoon',
    hover: 'BlueDawn',
    darkHover: 'BlueHeaven'
  },
  Tomato: {
    active: 'TomatoFlash',
    hover: 'TomatoDark',
    darkHover: 'TomatoLight'
  },
  GreyDark: {
    active: 'BlueMoon',
    hover: 'BlueDark'
  },
  White: {
    active: 'Grey',
    hover: 'BlueLight',
    focus: 'Grey'
  },
  BlueDawn: {
    active: 'Black',
    hover: 'BlueNight'
  }
};
var sizes = {
  sm: {
    fontSize: '1.2rem',
    lineHeight: '1.6rem'
  },
  md: {
    fontSize: '1.4rem',
    lineHeight: '1.8rem'
  },
  lg: {
    fontSize: '1.6rem',
    lineHeight: '2rem'
  },
  xl: {
    fontSize: '1.8rem',
    lineHeight: '2.2rem'
  }
};
var StyledLink = styled.a.withConfig({
  displayName: "Link__StyledLink",
  componentId: "sc-8rbjru-0"
})(["position:relative;max-width:100%;margin:", ";padding:0;line-height:", ";display:inline;font-family:", ";font-size:", ";color:", ";text-decoration:", ";transition:color .2s ease-in-out,border .2s ease-in-out,background-color .2s ease-in-out;word-break:break-word;> *{max-width:100%;}", " &:hover{color:", ";}&:focus{color:", ";outline:none;}&.focus-visible{background-color:", ";}&:active{color:", ";}", " > *{flex:0 0 auto;}svg{width:", " !important;height:", " !important;vertical-align:text-top;}path,rect{transition:fill .2s ease-in-out;fill:", ";}&:hover{path,rect{fill:", ";}}&:focus{path,rect{fill:", ";}}"], function (props) {
  return !props.render && props.margin;
}, function (props) {
  return props.inherit || props.size === 'inherit' ? 'inherit' : sizes[props.size] && sizes[props.size].lineHeight;
}, function (props) {
  return props.inherit ? 'inherit' : getFont(props.theme, props.isSemiBold ? 'semiBold' : 'regular');
}, function (props) {
  return props.inherit || props.size === 'inherit' ? 'inherit' : sizes[props.size] && sizes[props.size].fontSize;
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[Object.keys(linkColors).find(function (color) {
    return color === props.color;
  })];
}, function (props) {
  return props.inherit ? 'underline' : props.underline ? 'underline' : 'none';
}, function (props) {
  return props.kind === 'withBackground' && "padding: ".concat(props.size === 'sm' ? '1.2rem' : props.size === 'md' ? '1.2rem 1.6rem' : '1.2rem 2rem', ";\n      background-color: ").concat(colors.BlueSmoke, ";\n      border-radius: .8rem;\n      max-width: 100%;\n\n      &:hover, &:active {\n        background-color: ").concat(colors.BlueLight, ";\n      }\n    ");
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[linkColors[props.color].focus] ? colors[linkColors[props.color].focus] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, colors.BlueCloudyTransparent, function (props) {
  return colors[linkColors[props.color].active];
}, function (props) {
  return props.disabled && "\n    &, &:hover, &:focus {\n      cursor: not-allowed;\n      pointer-events: none;\n      text-decoration: none;\n      color: ".concat(colors.GreyMedium, ";\n      path, rect {\n        fill: ").concat(colors.GreyMedium, ";\n      }\n    }\n  ");
}, function (props) {
  return calcIconWidth(props.size);
}, function (props) {
  return calcIconWidth(props.size);
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[Object.keys(linkColors).find(function (color) {
    return color === props.color;
  })];
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[linkColors[props.color].focus] ? colors[linkColors[props.color].focus] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
});
var ButtonAsLink = styled.button.withConfig({
  displayName: "Link__ButtonAsLink",
  componentId: "sc-8rbjru-1"
})(["position:relative;max-width:100%;margin:", ";padding:0;line-height:", ";display:inline;font-family:", ";font-size:", ";color:", ";text-decoration:", ";transition:color .2s ease-in-out,border .2s ease-in-out,background-color .2s ease-in-out;word-break:break-word;> *{max-width:100%;}", " &:hover{color:", ";}&:focus{color:", ";outline:none;}&.focus-visible{background-color:", ";}&:active{color:", ";}", " > *{flex:0 0 auto;}svg{width:", " !important;height:", " !important;vertical-align:text-top;}path,rect{transition:fill .2s ease-in-out;fill:", ";}&:hover{path,rect{fill:", ";}}&:focus{path,rect{fill:", ";}}border:none;text-align:left;", " ", ""], function (props) {
  return !props.render && props.margin;
}, function (props) {
  return props.inherit || props.size === 'inherit' ? 'inherit' : sizes[props.size] && sizes[props.size].lineHeight;
}, function (props) {
  return props.inherit ? 'inherit' : getFont(props.theme, props.isSemiBold ? 'semiBold' : 'regular');
}, function (props) {
  return props.inherit || props.size === 'inherit' ? 'inherit' : sizes[props.size] && sizes[props.size].fontSize;
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[Object.keys(linkColors).find(function (color) {
    return color === props.color;
  })];
}, function (props) {
  return props.inherit ? 'underline' : props.underline ? 'underline' : 'none';
}, function (props) {
  return props.kind === 'withBackground' && "padding: ".concat(props.size === 'sm' ? '1.2rem' : props.size === 'md' ? '1.2rem 1.6rem' : '1.2rem 2rem', ";\n      background-color: ").concat(colors.BlueSmoke, ";\n      border-radius: .8rem;\n      max-width: 100%;\n\n      &:hover, &:active {\n        background-color: ").concat(colors.BlueLight, ";\n      }\n    ");
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[linkColors[props.color].focus] ? colors[linkColors[props.color].focus] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, colors.BlueCloudyTransparent, function (props) {
  return colors[linkColors[props.color].active];
}, function (props) {
  return props.disabled && "\n    &, &:hover, &:focus {\n      cursor: not-allowed;\n      pointer-events: none;\n      text-decoration: none;\n      color: ".concat(colors.GreyMedium, ";\n      path, rect {\n        fill: ").concat(colors.GreyMedium, ";\n      }\n    }\n  ");
}, function (props) {
  return calcIconWidth(props.size);
}, function (props) {
  return calcIconWidth(props.size);
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[Object.keys(linkColors).find(function (color) {
    return color === props.color;
  })];
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[linkColors[props.color].focus] ? colors[linkColors[props.color].focus] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, function (props) {
  return props.kind === 'default' && 'background-color: transparent;';
}, function (props) {
  return !props.disabled && 'cursor: pointer;';
});
var RenderWrapper = styled.span.withConfig({
  displayName: "Link__RenderWrapper",
  componentId: "sc-8rbjru-2"
})(["margin:", ";display:inline-flex;align-items:center;> *{flex:0 0 auto;}svg{width:", " !important;height:", " !important;vertical-align:text-top;}path,rect{transition:fill .2s ease-in-out;fill:", ";}&:hover{path,rect{fill:", ";}}&:focus{path,rect{fill:", ";}}a{position:relative;max-width:100%;margin:", ";padding:0;line-height:", ";display:inline;font-family:", ";font-size:", ";color:", ";text-decoration:", ";transition:color .2s ease-in-out,border .2s ease-in-out,background-color .2s ease-in-out;word-break:break-word;> *{max-width:100%;}", " &:hover{color:", ";}&:focus{color:", ";outline:none;}&.focus-visible{background-color:", ";}&:active{color:", ";}", " > *{flex:0 0 auto;}svg{width:", " !important;height:", " !important;vertical-align:text-top;}path,rect{transition:fill .2s ease-in-out;fill:", ";}&:hover{path,rect{fill:", ";}}&:focus{path,rect{fill:", ";}}}button{position:relative;max-width:100%;margin:", ";padding:0;line-height:", ";display:inline;font-family:", ";font-size:", ";color:", ";text-decoration:", ";transition:color .2s ease-in-out,border .2s ease-in-out,background-color .2s ease-in-out;word-break:break-word;> *{max-width:100%;}", " &:hover{color:", ";}&:focus{color:", ";outline:none;}&.focus-visible{background-color:", ";}&:active{color:", ";}", " > *{flex:0 0 auto;}svg{width:", " !important;height:", " !important;vertical-align:text-top;}path,rect{transition:fill .2s ease-in-out;fill:", ";}&:hover{path,rect{fill:", ";}}&:focus{path,rect{fill:", ";}}border:none;text-align:left;", " ", "}"], function (props) {
  return props.margin;
}, function (props) {
  return calcIconWidth(props.size);
}, function (props) {
  return calcIconWidth(props.size);
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[Object.keys(linkColors).find(function (color) {
    return color === props.color;
  })];
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[linkColors[props.color].focus] ? colors[linkColors[props.color].focus] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, function (props) {
  return !props.render && props.margin;
}, function (props) {
  return props.inherit || props.size === 'inherit' ? 'inherit' : sizes[props.size] && sizes[props.size].lineHeight;
}, function (props) {
  return props.inherit ? 'inherit' : getFont(props.theme, props.isSemiBold ? 'semiBold' : 'regular');
}, function (props) {
  return props.inherit || props.size === 'inherit' ? 'inherit' : sizes[props.size] && sizes[props.size].fontSize;
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[Object.keys(linkColors).find(function (color) {
    return color === props.color;
  })];
}, function (props) {
  return props.inherit ? 'underline' : props.underline ? 'underline' : 'none';
}, function (props) {
  return props.kind === 'withBackground' && "padding: ".concat(props.size === 'sm' ? '1.2rem' : props.size === 'md' ? '1.2rem 1.6rem' : '1.2rem 2rem', ";\n      background-color: ").concat(colors.BlueSmoke, ";\n      border-radius: .8rem;\n      max-width: 100%;\n\n      &:hover, &:active {\n        background-color: ").concat(colors.BlueLight, ";\n      }\n    ");
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[linkColors[props.color].focus] ? colors[linkColors[props.color].focus] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, colors.BlueCloudyTransparent, function (props) {
  return colors[linkColors[props.color].active];
}, function (props) {
  return props.disabled && "\n    &, &:hover, &:focus {\n      cursor: not-allowed;\n      pointer-events: none;\n      text-decoration: none;\n      color: ".concat(colors.GreyMedium, ";\n      path, rect {\n        fill: ").concat(colors.GreyMedium, ";\n      }\n    }\n  ");
}, function (props) {
  return calcIconWidth(props.size);
}, function (props) {
  return calcIconWidth(props.size);
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[Object.keys(linkColors).find(function (color) {
    return color === props.color;
  })];
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[linkColors[props.color].focus] ? colors[linkColors[props.color].focus] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, function (props) {
  return !props.render && props.margin;
}, function (props) {
  return props.inherit || props.size === 'inherit' ? 'inherit' : sizes[props.size] && sizes[props.size].lineHeight;
}, function (props) {
  return props.inherit ? 'inherit' : getFont(props.theme, props.isSemiBold ? 'semiBold' : 'regular');
}, function (props) {
  return props.inherit || props.size === 'inherit' ? 'inherit' : sizes[props.size] && sizes[props.size].fontSize;
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[Object.keys(linkColors).find(function (color) {
    return color === props.color;
  })];
}, function (props) {
  return props.inherit ? 'underline' : props.underline ? 'underline' : 'none';
}, function (props) {
  return props.kind === 'withBackground' && "padding: ".concat(props.size === 'sm' ? '1.2rem' : props.size === 'md' ? '1.2rem 1.6rem' : '1.2rem 2rem', ";\n      background-color: ").concat(colors.BlueSmoke, ";\n      border-radius: .8rem;\n      max-width: 100%;\n\n      &:hover, &:active {\n        background-color: ").concat(colors.BlueLight, ";\n      }\n    ");
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[linkColors[props.color].focus] ? colors[linkColors[props.color].focus] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, colors.BlueCloudyTransparent, function (props) {
  return colors[linkColors[props.color].active];
}, function (props) {
  return props.disabled && "\n    &, &:hover, &:focus {\n      cursor: not-allowed;\n      pointer-events: none;\n      text-decoration: none;\n      color: ".concat(colors.GreyMedium, ";\n      path, rect {\n        fill: ").concat(colors.GreyMedium, ";\n      }\n    }\n  ");
}, function (props) {
  return calcIconWidth(props.size);
}, function (props) {
  return calcIconWidth(props.size);
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[Object.keys(linkColors).find(function (color) {
    return color === props.color;
  })];
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[linkColors[props.color].focus] ? colors[linkColors[props.color].focus] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, function (props) {
  return props.kind === 'default' && 'background-color: transparent;';
}, function (props) {
  return !props.disabled && 'cursor: pointer;';
});
var calcIconWidth = function calcIconWidth(textLinkSize) {
  switch (textLinkSize) {
    case 'sm':
      return '1.6rem';
    case 'md':
      return '2rem';
    case 'lg':
      return '2.4rem';
  }
};
var StyledLoader = styled.div.withConfig({
  displayName: "Link__StyledLoader",
  componentId: "sc-8rbjru-3"
})(["svg{animation:rotate 0.8s steps(12,end) infinite;}@keyframes rotate{from{transform:rotate(0deg);}to{transform:rotate(360deg);}}"]);
var RenderedElement = function RenderedElement(props) {
  return props.render ? /*#__PURE__*/React.createElement(RenderWrapper, props) : props.href ? /*#__PURE__*/React.createElement(StyledLink, props) : /*#__PURE__*/React.createElement(ButtonAsLink, _extends({}, props, {
    type: props.type || 'button'
  }));
};
var Link = function Link(props) {
  var href = props.href,
    targetBlank = props.targetBlank,
    size = props.size,
    children = props.children,
    onClick = props.onClick,
    iconLeft = props.iconLeft,
    iconRight = props.iconRight,
    inherit = props.inherit,
    kind = props.kind,
    className = props.className,
    underline = props.underline,
    isSemiBold = props.isSemiBold,
    color = props.color,
    isLoading = props.isLoading,
    margin = props.margin,
    disabled = props.disabled,
    render = props.render,
    download = props.download,
    type = props.type,
    form = props.form;
  var colorAllowed = kind === 'withBackground' ? 'BlueDawn' : color;
  return /*#__PURE__*/React.createElement(RenderedElement, {
    form: form,
    margin: margin,
    size: size,
    className: className,
    inherit: inherit,
    isSemiBold: isSemiBold,
    underline: underline,
    kind: kind,
    iconLeft: iconLeft,
    iconRight: iconRight,
    href: href,
    type: type,
    onClick: disabled ? null : onClick ? function (event) {
      return onClick(event, href, targetBlank);
    } : null,
    target: href && targetBlank ? '_blank' : null,
    rel: href ? targetBlank ? 'noopener noreferrer' : 'noreferrer' : null,
    color: colorAllowed,
    isLoading: isLoading,
    disabled: disabled,
    render: render,
    download: download
  }, isLoading && /*#__PURE__*/React.createElement(StyledLoader, {
    isLoading: isLoading
  }, /*#__PURE__*/React.createElement(SpinnerIcon, {
    color: colors[colorAllowed],
    isLoading: isLoading
  })), !isLoading && iconLeft, render ? render() : children, !isLoading && iconRight);
};
Link.defaultProps = {
  size: 'md',
  color: 'BlueSky',
  kind: 'default'
};
exports.Link = Link;